import { gql } from '@apollo/client';

export const CREATE_COMMUNITY_POLICY = gql`
  mutation CreateCommunityPolicy($communityId: ID!, $input: CreatePolicyInput!) {
    createPolicy(communityId: $communityId, input: $input) {
      id
      communityId
      name
      description
      isEnabled
      workflowType
      labels {
        labelId
        severity
        scoreThreshold
      }
      createdBy
      createdAt
      lastModifiedBy
      lastModifiedAt
    }
  }
`;
